module.exports = __webpack_public_path__ + "img/appeal_desc.79364fb0.jpg";